export const GEM_GPT_ROUTE = '/gem-gpt';
export const USERS_ROUTE = '/users';
export const PAYMENTS_ROUTE = '/payments';
export const SETTINGS_ROUTE = '/settings';
export const MY_GEM_VAULT_ROUTE = '/my-gem-vault';
export const MY_GEM_FAV_ROUTE = '/my-gem-fav';
export const MY_PROFILE_ROUTE = '/my-profile';
export const CREATE_PIN_ROUTE = '/create-pin';
export const POROLIS_GEM_BANK_ROUTE = '/gem-bank';
export const SUBORDINATES_ROUTE = '/subordinates';
export const INVITATIONS_ROUTE = '/invitations';
export const SUBORDINATES_SIGN_IN_ROUTE = '/subordinates/sign-in';
export const NCC_SUBORDINATES_SIGN_IN_ROUTE = '/subordinates/ncc/sign-in';
export const GEM_FULL_DETAILS_ROUTE = '/gem-bank/:gemId';
export const MANAGE_SUBSCRIPTION = '/manage-subscription';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const SIGN_UP_ROUTE = '/sign-up';
export const LOGIN_ROUTE = '/login';
export const CONTACT_US_ROUTE = '/contact-us';
export const GEM_RECORD_ROUTE = '/my-gem-vault/:gemId';
export const GEM_RECORD_ROUTE_FAV = '/my-gem-fav/:gemId';
export const ACCOUNT_ACTIVATION_SUCCESS = '/activation-success';
export const ACCOUNT_LOCKED_ROUTE = '/account-locked';
export const TERMS_AND_CONDITIONS_ROUTE = '/terms&conditions';
export const INVITE_USER_ROUTE = '/invite/:token';
export const INVITE_NCC_USER_ROUTE = '/ncc/invite/:token';
export const RESET_PASSWORD_ROUTE = '/reset-password';
